import { render, staticRenderFns } from "./OrderDetailECCode.vue?vue&type=template&id=1d71a3bc&scoped=true&"
import script from "./OrderDetailECCode.vue?vue&type=script&lang=js&"
export * from "./OrderDetailECCode.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailECCode.vue?vue&type=style&index=0&id=1d71a3bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d71a3bc",
  null
  
)

export default component.exports